{
  "title": "Adapter Details",
  "blocks": [
    {
      "type": "adapter-info",
      "adapterNameGetter": "context.queryParams.adapterName"
    },
    {
      "type": "message",
      "title": "{{label}} Adapter",
      "message": "{{description}}"
    },
    {
      "type": "debug",
      "open": 0,
      "showContext": true
    },
    {
      "type": "multi",
      "batches": [
        {
          "blocks": [
            {
              "type": "actions",
              "buttons": [
                {
                  "label": "Export",
                  "blocks": [
                    {
                      "type": "dispatch",
                      "action": "exportAdapter"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "blocks": [
            {
              "type": "message",
              "title": "Database schemas"
            },
            {
              "type": "mapping",
              "mapping": "data.database"
            },
            {
              "type": "grid",
              "columnDefs": [
                {
                  "headerName": "Schema name",
                  "field": "name"
                },
                {
                  "headerName": "Operations",
                  "cellRenderer": "workflowRenderer",
                  "cellRendererParams": {
                    "blocks": [
                      {
                        "type": "actions",
                        "buttons": [
                          {
                            "label": "View",
                            "color": "primary",
                            "blocks": [
                              {
                                "type": "launch",
                                "adapter": "core",
                                "workflowId": "databaseSchema",
                                "context": {
                                  "adapterName": "context.queryParams.adapterName",
                                  "schemaName": "data.name"
                                }
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "blocks": [
            {
              "type": "message",
              "title": "Cloud workflows"
            },
            {
              "type": "http",
              "method": "get",
              "endpoint": "https://us-central1-kendraioworkflowstorage.cloudfunctions.net/api"
            },
            {
              "type": "mapping",
              "mapping": "data[?adapterName == $.context.queryParams.adapterName]"
            },
            {
              "type": "grid",
              "gridOptions": {
                "pagination": true,
                "paginationPageSize": 15,
                "defaultColDef": {
                  "sortable": true,
                  "resizable": true
                }
              },
              "columnDefs": [
                {
                  "headerName": "Title",
                  "field": "title",
                  "width": 300,
                  "filter": true
                },
                {
                  "headerName": "Operations",
                  "cellRenderer": "workflowRenderer",
                  "cellRendererParams": {
                    "blocks": [
                      {
                        "type": "actions",
                        "buttons": [
                          {
                            "label": "Launch",
                            "blocks": [
                              {
                                "type": "launch",
                                "valueGetters": {
                                  "adapter": "data.adapterName",
                                  "workflowId": "data.id"
                                }
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                },
                {
                  "headerName": "Workflow ID",
                  "field": "id"
                },
                {
                  "headerName": "Adapter",
                  "field": "adapterName",
                  "filter": true
                },
                {
                  "headerName": "Created",
                  "field": "created",
                  "valueFormatter": "formatDate(value, 'ff')"
                },
                {
                  "headerName": "Modified",
                  "field": "modified",
                  "sort": "desc",
                  "valueFormatter": "formatDate(value, 'ff')"
                }
              ]
            }
          ]
        },
        {
          "blocks": [
            {
              "type": "message",
              "title": "Workflows"
            },
            {
              "type": "mapping",
              "mapping": "data.workflow"
            },
            {
              "type": "multi",
              "batches": [
                {
                  "blocks": [
                    {
                      "type": "actions",
                      "buttons": [
                        {
                          "label": "New workflow",
                          "blocks": [
                            {
                              "type": "launch",
                              "adapter": "core",
                              "workflowId": "newWorkflow",
                              "context": {
                                "adapterName": "context.queryParams.adapterName"
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "blocks": [
                    {
                      "type": "grid",
                      "columnDefs": [
                        {
                          "headerName": "Workflow title",
                          "field": "title"
                        },
                        {
                          "headerName": "ID",
                          "field": "workflowId"
                        },
                        {
                          "headerName": "Modified",
                          "valueGetter": "modified && 'yes' || 'no'"
                        },
                        {
                          "headerName": "Operations",
                          "cellRenderer": "workflowRenderer",
                          "cellRendererParams": {
                            "blocks": [
                              {
                                "type": "actions",
                                "buttons": [
                                  {
                                    "label": "View",
                                    "color": "primary",
                                    "blocks": [
                                      {
                                        "type": "launch",
                                        "valueGetters": {
                                          "adapter": "context.queryParams.adapterName",
                                          "workflowId": "data.workflowId"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "label": "Clone",
                                    "blocks": [
                                      {
                                        "type": "launch",
                                        "adapter": "core",
                                        "workflowId": "cloneWorkflow",
                                        "context": {
                                          "adapter": "context.queryParams.adapterName",
                                          "workflowId": "data.workflowId"
                                        }
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "blocks": [
            {
              "type": "message",
              "title": "Forms"
            },
            {
              "type": "mapping",
              "mapping": "data.forms"
            },
            {
              "type": "grid"
            }
          ]
        },
        {
          "blocks": [
            {
              "type": "message",
              "title": "APIs"
            },
            {
              "type": "mapping",
              "mapping": "data.apis[].{ config: @ }"
            },
            {
              "type": "grid"
            }
          ]
        }
      ]
    }
  ],
  "id": "adapterDetails"
}
